import Base from '@studiometa/js-toolkit';

/**
 * @typedef {Object} PageRefs
 * @property {HTMLAnchorElement[]} links
 */

/**
 * @typedef {Object} PageInterface
 * @property {PageRefs} $refs
 */

/**
 * Page class.
 */
export default class Pager extends Base {
  /**
   * Class config.
   */
  get config() {
    return {
      name: 'Pager',
      refs: ['links[]'],
    };
  }

  /**
   * Hook to alter the links.
   *
   * @this {Pager & PagerInterface}
   * @param {(link:HTMLAnchorElement, index:number, instance:Pager) => void} callback
   * @return {void}
   */
  alterLinks(callback) {
    if (typeof callback !== 'function' || !Array.isArray(this.$refs.links)) {
      return;
    }

    this.$refs.links.forEach((link, index) => {
      callback(link, index, this);
    });
  }
}
